import { RemindUnitProps } from '@/src/types/common';
import { useMemo } from 'react';
import { CommunicationChannelType } from 'src/types/common/communication';

enum EGateway {
  Twilio = 'Twilio',
  Cloopen = 'Cloopen',
  Sendgrid = 'Sendgrid',
}

export const calc2Minute = (time: number, unit: RemindUnitProps): number => {
  if (!time) {
    return 0;
  }
  if (unit === RemindUnitProps.Days || unit === RemindUnitProps.RollingDays) {
    return time * 24 * 60;
  } else if (unit === RemindUnitProps.Hours) {
    return time * 60;
  }
  return Infinity;
};

const useTemplates = ({ category, templates: t, channelType }) => {
  //const { category, templates: t, channelType } = props;

  const _t = useMemo(() => {
    if (channelType === CommunicationChannelType.Email) {
      return t.filter((i) => {
        if (category) {
          return (
            // i.communicationGatewayName === EGateway.Sendgrid &&
            i.category === category
          );
        } else {
          return i.communicationGatewayName === EGateway.Sendgrid; //等以后再改进 provider
        }
      });
    }
    if (channelType === CommunicationChannelType.SMS) {
      return t.filter((i) => {
        if (category) {
          return (
            // (i.communicationGatewayName === EGateway.Cloopen ||
            //   i.communicationGatewayName === EGateway.Twilio) &&
            i.category === category
          );
        } else {
          return (
            //等以后再改进 provider
            i.communicationGatewayName === EGateway.Cloopen ||
            i.communicationGatewayName === EGateway.Twilio
          );
        }
      });
    }
    return t;
  }, [t]);
  return _t;
};
export { useTemplates };
